(ns app.front.view.application-wizard.save-status
  "Save-status indicator for the application wizard. The operation registry and its events live in
  app.front.process.save-tracking; this namespace only renders the indicator from ::save-tracking/status."
  (:require [app.front.process.save-tracking :as save-tracking]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]))

(def ^:private status-appearances
  "How each tracked save status is presented: the accent classes on the container, what occupies
  the icon slot while the status is announced, and the translation key for the label."
  (array-map
    :saving {:class "border-gray-500 bg-gray-100"
             :icon  [cc/loading-spinner {:with-overlay false :small true}]
             :label :saving}
    :saved  {:class "border-status-success bg-green-200"
             :icon  [cc/icon {:icon        i/check
                              :description ""
                              :aria-hidden true
                              :width       "16"}]
             :label :changes-saved}
    :failed {:class "border-status-error bg-ui-red-10"
             :icon  [cc/icon {:icon        i/warning
                              :description ""
                              :aria-hidden true
                              :width       "16"}]
             :label :changes-not-saved}))

(defn- indicator-content
  "Renders one status appearance. With announce? false this is sizing scaffolding only: hidden
  from assistive tech, with a blank spacer in place of the icon."
  [tr {:keys [class icon label]} announce?]
  [:div.flex.items-center.gap-2.rounded.border-l-4.border-solid.px-4.py-2.text-sm.font-semibold
   (merge {:class class}
          (if announce?
            {:role "status" :aria-live "polite"}
            {:aria-hidden true}))
   (if announce? icon [:span.inline-block.h-4.w-4])
   [:span (tr [label])]])

(defn indicator
  "Save-status indicator for the wizard header."
  [{:keys [tr class-name]}]
  (let [status (<sub [::save-tracking/status])]
    [:div.grid {:class class-name}
     ;; Every label is rendered invisibly into the same grid cell so the cell is always as wide
     ;; as the widest one. Without these the header would jump around as the status changes.
     (for [[status-key appearance] status-appearances]
       ^{:key status-key}
       [:div.invisible.col-start-1.row-start-1.justify-self-end
        [indicator-content tr appearance false]])
     (when-let [appearance (status-appearances status)]
       [:div.col-start-1.row-start-1.justify-self-end
        [indicator-content tr appearance true]])]))
